export default __webpack_public_path__ + "static/media/i1.337d5462.jpg";